import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=e639b02c&scoped=true&"
import script from "./UsersList.vue?vue&type=script&lang=ts&"
export * from "./UsersList.vue?vue&type=script&lang=ts&"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=e639b02c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e639b02c",
  null
  
)

export default component.exports